import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { buildAetUserContext, getPreferredUserIdentifier } from '../core/constant/user-context.util';

@Injectable({
  providedIn: 'root',
})
export class AetSafetyDashboardService {
  baseURL = environment.baseAPIURL;

  constructor(private readonly http: HttpClient) {}

  loadMasterGrid() {
    return this.http
      .get(`${this.baseURL}/aetSafetyDashboard/getSafetyDashboard`, { responseType: 'json' })
      .pipe(catchError(this.handleError));
  }

  callingDropDowns(): Promise<any> {
    return this.http
      .get(`${this.baseURL}/aetSafetyDashboard/loadSafetyEventDetails`)
      .pipe(
        catchError(() => this.http.get(`${this.baseURL}/aetNotifications/GetCriteriaFilters`)),
        catchError(this.handleError),
      )
      .toPromise();
  }

  // Wrap JSON bodies into { event, userReqDto } for consistency.
  imageResolutionCall(safetyEventId: any, safetyEventFinalId: any) {
    const requestBody = {
      safetyEventId,
      safetyEventFinalId,
      event: { safetyEventId, safetyEventFinalId },
      userReqDto: buildAetUserContext(),
    };
    return this.http
      .post(`${this.baseURL}/aetSafetyDashboard/getEventSafetyResolutions/getSafetyImageDetails`, requestBody, { responseType: 'json' })
      .pipe(catchError(this.handleError));
  }

  reopenEvent(id: any, toyotaGUID: any) {
    const userIdentifier = getPreferredUserIdentifier(toyotaGUID);
    const requestBody = {
      event: { safetyEventId: id },
      userReqDto: buildAetUserContext(),
    };
    return this.http
      .put(`${this.baseURL}/aetSafetyDashboard/reOpenSafetyEvent/${id}`, requestBody, { responseType: 'text' })
      .pipe(catchError(this.handleError));
  }

  childGridCall(requestBody: any) {
    const rb = { event: requestBody, userReqDto: buildAetUserContext() };
    return this.http
      .post(`${this.baseURL}/aetSafetyDashboard/getEventSafetyResolutions`, rb, { responseType: 'json' })
      .pipe(catchError(this.handleError));
  }

  updatesafetyDashboard(requestBody: any) {
    const rb = { event: requestBody, userReqDto: buildAetUserContext() };
    return this.http
      .put(`${this.baseURL}/aetSafetyDashboard/editSafetyDashboardEvent`, rb, { responseType: 'text' })
      .pipe(catchError(this.handleError));
  }

  updateFinalsafetyDashboard(requestBody: any) {
    const rb = { event: requestBody, userReqDto: buildAetUserContext() };
    return this.http
      .put(`${this.baseURL}/aetSafetyDashboard/setupSafetyEventResolutionEdit`, rb, { responseType: 'text' })
      .pipe(catchError(this.handleError));
  }

  deleteEvent(id: any) {
    const requestBody = { event: { safetyEventId: id }, userReqDto: buildAetUserContext() };
    return this.http
      .post(`${this.baseURL}/aetSafetyDashboard/deleteAETSafetyEvent`, requestBody, { responseType: 'text' })
      .pipe(catchError(this.handleError));
  }

  closeEvent(id: any) {
    const requestBody = { event: { safetyEventId: id }, userReqDto: buildAetUserContext() };
    return this.http
      .post(`${this.baseURL}/aetSafetyDashboard/closeAETSafetyEvent`, requestBody, { responseType: 'text' })
      .pipe(catchError(this.handleError));
  }

  imagePopUp(safetyEventId: any, safetyEventFinalId: any, file: any) {
    const formData: FormData = new FormData();
    formData.append('safetyEventId', safetyEventId);
    formData.append('safetyEventFinalId', safetyEventFinalId);
    formData.append('imagefile', file);
    return this.http.post(`${this.baseURL}/aetSafetyDashboard/uploadAETSafetyEventImage`, formData, { responseType: 'text' }).pipe(catchError(this.handleError));
  }

  generatingPdf(id: any) {
    return this.http.get(`${this.baseURL}/aetSafetyDashboard/fetchSafetyEventForm/${id}`, { responseType: 'blob' }).pipe(catchError(this.handleError));
  }

  getExcel(toyotaGUID: any, inputBody: any) {
    const userIdentifier = getPreferredUserIdentifier(toyotaGUID);
  const url: string = environment.baseAPIURL + `/aetReport/aetSafetyDashboard`;
    const requestBody = {
      event: inputBody,
      userReqDto: buildAetUserContext(),
    };
    return this.http.post(url, requestBody, { observe: 'response', responseType: 'blob' }).pipe(catchError(this.handleError));
  }

  deleteimageAsAsked(safetyEventId: any, safetyEventFinalId: any, timageId: any) {
    const inputjson = {
      timageId: timageId,
      safetyEventId: safetyEventId,
      safetyEventFinalId: safetyEventFinalId,
      event: { timageId: timageId, safetyEventId: safetyEventId, safetyEventFinalId: safetyEventFinalId },
      userReqDto: buildAetUserContext(),
    };
    return this.http.post(`${this.baseURL}/aetSafetyDashboard/deleteSafetyEventsResolutionImage`, inputjson, { responseType: 'text' }).pipe(catchError(this.handleError));
  }

  //KPI code
  getFilter() {
    return this.http
      .get(`${this.baseURL}/aetSafetyDashboard/loadSafetyEventDetails`)
      .pipe(
        catchError(() => this.http.get(`${this.baseURL}/aetNotifications/GetCriteriaFilters`)),
        catchError(this.handleError),
      );
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(() => new Error(error.message || 'Server Error'));
  }
}